import { Alert, Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import NetZeroRemark, { NET_ZERO_REMARK_ID } from './NetZeroRemark';
import NetZeroDetail from './NetZeroDetail';

const NetZero = () => {
  return (
    <Box width={'100%'} mt={2}>
      <Flex gap={1} alignItems={'center'}>
        <Typography fontWeight={'bold'}>
          การตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกสุทธิเป็นศูนย์ (Net-Zero
          Greenhouse Gas Emissions)
        </Typography>
        <NetZeroRemark />
      </Flex>
      <Alert severity="info" sx={{ mt: 2 }}>
        คำชี้แจง : กรุณาระบุรายละเอียดการตั้งเป้าหมาย
        โดยสามารถเพิ่มเป้าหมายได้หลายข้อ
      </Alert>
      <NetZeroDetail />
      <Box id={NET_ZERO_REMARK_ID} />
    </Box>
  );
};

export default NetZero;
